import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { APPROVEAGENT } from "../util/constants.js";
import { cloneData } from "../util/util.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";
export default class ApproveAgent {
    static buildRequest(paprvAgtObj) {
        let returnValue = null;
        try {
            let body = null;

            paprvAgtObj = cloneData(paprvAgtObj);
            paprvAgtObj.agencyInfo.agencyDet.registrationid = isNaN(
                    parseInt(paprvAgtObj.agencyInfo.agencyDet.registrationid)
                ) ?
                null :
                parseInt(paprvAgtObj.agencyInfo.agencyDet.registrationid);

            paprvAgtObj.agtType.postPaidType.selTypeVal.value = isNaN(
                    parseInt(paprvAgtObj.agtType.postPaidType.selTypeVal.value)
                ) ?
                null :
                parseInt(paprvAgtObj.agtType.postPaidType.selTypeVal.value);

            paprvAgtObj.agtType.postPaidType.selCreditLimit.value = isNaN(
                    parseInt(paprvAgtObj.agtType.postPaidType.selCreditLimit.value)
                ) ?
                null :
                parseInt(paprvAgtObj.agtType.postPaidType.selCreditLimit.value);

            paprvAgtObj.agencyInfo.agencyDet.extensionTime = isNaN(
                    parseInt(paprvAgtObj.agencyInfo.agencyDet.extensionTime)
                ) ?
                null :
                parseInt(paprvAgtObj.agencyInfo.agencyDet.extensionTime);

            if (paprvAgtObj.agtType.agentType.value == APPROVEAGENT.PREPAID) {
                body = this.getReqforprepaid(paprvAgtObj);
            } else {
                body = this.getReqforPostpaid(paprvAgtObj);
            }

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.APPROVE_AGENT,
                "error in building body for APPROVE_AGENT api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.APPROVE_AGENT,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.APPROVE_AGENT,
                "error in getting Response from  APPROVE_AGENT api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static getReqforprepaid(paprvAgtObj) {
        let retValue;
        try {
            paprvAgtObj.agtType.postPaidType.selTypeVal.value = null;
            paprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid = null;
            retValue = {
                registrationid: paprvAgtObj.agencyInfo.agencyDet.registrationid,
                agenttype: paprvAgtObj.agtType.agentType.value,
                postpaidtype: paprvAgtObj.agtType.postPaidType.selTypeVal.value,
                schedule: paprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid,
                contactCountrycode: paprvAgtObj.selCity.country.countrycode,
                contact_state: paprvAgtObj.selCity.state.statecode,
                paymentSettingId: paprvAgtObj.paymentSettingId,
                b2bCompanyFinancess: this.getb2bFinances(paprvAgtObj)
            };

            //this.getb2bFinances();
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.apiApproveAgent,
                "error in getReqforprepaid",
                err.toString(),
                "getReqforprepaid",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return retValue;
    }

    static getReqforPostpaid(paprvAgtObj) {
        let retValue;
        try {
            retValue = {
                registrationid: paprvAgtObj.agencyInfo.agencyDet.registrationid,
                agenttype: paprvAgtObj.agtType.agentType.value,
                postpaidtype: paprvAgtObj.agtType.postPaidType.selTypeVal.value,
                schedule: paprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid,
                contactCountrycode: paprvAgtObj.selCity.country.countrycode,
                contact_state: paprvAgtObj.selCity.state.statecode,
                paymentSettingId: paprvAgtObj.paymentSettingId,
                b2bCompanyFinancess: this.getb2bFinances(paprvAgtObj),
                creditlimit_type: paprvAgtObj.agtType.postPaidType.selCreditLimit.value,
                max_stmt_extenstion_times:paprvAgtObj.agtType.postPaidType.extensionTime?paprvAgtObj.agtType.postPaidType.extensionTime:null,
                isBlockTicketIfOneStatementPending:paprvAgtObj.agtType.postPaidType.isBlockStatement
            };

            //this.getb2bFinances();
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.apiApproveAgent,
                "error in getReqforPostpaid",
                err.toString(),
                "getReqforPostpaid",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return retValue;
    }

    static getb2bFinances(paprvAgtObj) {
        let b2bFinance = {
            currencycode: null,
            prepaidbalance: null,
            postpaidlimit: null
        };

        let retValue = [];
        try {
            for (let i = 0; i < paprvAgtObj.payMethod.currency.length; i++) {
                var b2bObj = cloneData(b2bFinance);
                if (paprvAgtObj.agtType.agentType.value == APPROVEAGENT.PREPAID) {
                    b2bObj.currencycode =
                        paprvAgtObj.payMethod.currency[i].currency_code.code;
                    b2bObj.prepaidbalance = "0";
                    b2bObj.postpaidlimit = null;
                } else {
                    b2bObj.currencycode =
                        paprvAgtObj.payMethod.currency[i].currency_code.code;
                    b2bObj.prepaidbalance = null;
                    paprvAgtObj.payMethod.currency[i].amount=paprvAgtObj.payMethod.currency[i].amount.toString().split(",").join("");
                    b2bObj.postpaidlimit = isNaN(parseInt(paprvAgtObj.payMethod.currency[i].amount)) ? 0 : parseInt(paprvAgtObj.payMethod.currency[i].amount);
                }
                retValue.push(b2bObj);
            }
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.apiApproveAgent,
                "error in getb2bFinances",
                err.toString(),
                "getb2bFinances",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return retValue;
    }
}